<template>
	<div>
		<h3>Email preferences</h3>

		<b-form-group label="Types of emails to receive" v-slot="{ ariaDescribedby }">
			<b-form-checkbox-group
				stacked
				id="newsletter_categories"
				v-model="user.newsletter_categories"
				:options="options"
				:aria-describedby="ariaDescribedby"
				name="newsletter_categories"
			></b-form-checkbox-group>
		</b-form-group>

		<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
		<b-button @click="saveEmailSettings()" variant="success">Save</b-button>
		<b-spinner v-show="loading>0" small label="Spinning" class="mr-3"></b-spinner>
	</div>
</template>

<script>
export default {
	data: () => ({
		loading: 0,
		error: null,
		options: [
			{ text: 'New features and important platform messages', value: 'updates' },
			{ text: 'Developer updates', value: 'developer' },
		],
		user: {
			newsletter_categories: [],
		},
	}),
	created() {
		this.loadUserData();
	},
	methods: {
		async loadUserData() {
			try {
				this.loading++;
				const user = await this.$api.get('userData');
				user.newsletter_categories = Object.keys(user.newsletter_categories);
				this.user = user;
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},
		async saveEmailSettings() {
			try {
				this.loading++;
				await this.$api.post('userData', { newsletter_categories: Object.fromEntries(this.user.newsletter_categories.map(c => [ c, true ])) })
				this.$bvToast.toast('Successfully saved',{ title: 'Success', variant: 'success', solid: true });
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},
	},
}
</script>
